import * as Sentry from "@sentry/react";

let started = false;

/** Nama release yang dipakai untuk tagging Sentry + pencocokan sourcemap. */
export const RELEASE =
  (import.meta.env["VITE_APP_RELEASE"] as string | undefined) ??
  (import.meta.env["VITE_COMMIT_SHA"] as string | undefined) ??
  "jasasebar@dev";

/** Inisialisasi Sentry di browser. Aktif hanya bila VITE_SENTRY_DSN diisi. */
export function initMonitoring() {
  if (started || typeof window === "undefined") return;
  const dsn = import.meta.env["VITE_SENTRY_DSN"] as string | undefined;
  if (!dsn) return;
  started = true;
  Sentry.init({
    dsn,
    release: RELEASE,
    dist: (import.meta.env["VITE_APP_DIST"] as string | undefined) ?? undefined,
    environment: import.meta.env.DEV ? "development" : "production",
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    sendDefaultPii: false,
    attachStacktrace: true,
  });
  Sentry.setTag("release", RELEASE);
}

/** Kirim error ke Sentry dengan konteks rute; aman dipanggil walau Sentry nonaktif. */
export function captureMonitoringError(error: unknown, context: Record<string, unknown> = {}) {
  if (typeof window === "undefined" || !started) return;
  Sentry.captureException(error, {
    extra: { route: window.location.pathname, ...context },
  });
}
